import { v4 as uuidv4 } from 'uuid';
import { TrackedInfo } from '../global-constants';

const getDomainFromURL = (url) => {
	// Using try/catch block because the URL interfaces raises a typeError if supplied string is an invalid URL
	try {
		const domain = new URL(url);
		return domain.origin;
	} catch (e) {
		return '';
	}
};

const setUserSessionId = () => {
	let sessionId = sessionStorage.getItem(TrackedInfo.USER_SESSION_ID);

	// Creating a new session if sessionId is not successfully retrieved from storage.
	if (!sessionId) {
		sessionId = uuidv4().replaceAll('-', '');
		sessionStorage.setItem(TrackedInfo.USER_SESSION_ID, sessionId);
		// document.referrer will be "" if a page is navigated to directly.
		sessionStorage.setItem(
			TrackedInfo.SESSION_REFERRER,
			getDomainFromURL(document.referrer)
		);
		sessionStorage.setItem(
			TrackedInfo.SESSION_REFERRER_DOMAIN,
			getDomainFromURL(document.referrer)
		);
	}

	document.cookie = `__ssoid=${sessionId}; SameSite=None; Secure`;
	if (window.DDC?.dataLayer?.user) {
		window.DDC.dataLayer.user.sessionId = sessionId;
	}

	// Add the userSessionId value to the PageView event in New Relic.
	if (window?.newrelic) {
		window.newrelic.setCustomAttribute('userSessionId', sessionId);
	}
};

export default setUserSessionId;
